<div class="layout-topbar">
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="">
        <ng-container *ngIf="isSessionBootstrapping; else topbarBrand">
            <p-skeleton shape="circle" size="2.25rem" styleClass="mr-2"></p-skeleton>
            <p-skeleton width="9rem" height="1rem"></p-skeleton>
        </ng-container>
        <ng-template #topbarBrand>
            <img [src]="getCorrectLogoUrl(currentCompany)"
                 alt="logo"
                 (onError)="onImageError($event)">
            <span *ngIf="currentCompany?.companyName">{{currentCompany?.companyName }}</span>
            <span *ngIf="!currentCompany?.companyName && !hasMissingCompanyContext" class="text-muted">Contexto de compañía pendiente</span>
        </ng-template>
    </a>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">

        <button class="p-link layout-topbar-button notification-button" 
                [class.has-notifications]="notificationsCount?.unreadTotal > 0"
                [routerLink]="'/notifications/view'">
            <i class="pi pi-bell text-3xl" *ngIf="notificationsCount?.unreadTotal > 0" pBadge
                value="{{notificationsCount?.unreadTotal}}" severity="danger"></i>
            <i class="pi pi-bell text-3xl" *ngIf="notificationsCount?.unreadTotal === 0"></i>
        </button>

        <button (click)="openUserMenu($event)" class="p-link layout-topbar-button">

            <i class="pi pi-user"></i>
            <span>Profile</span>
        </button>

        <p-overlayPanel #op>

            <p-menu [model]="items" [style]="{'width': '300px'}">
                <ng-template pTemplate="start">
                    <button pRipple
                        class="relative overflow-hidden w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround">
                        <p-avatar *ngIf="user?.imageProfile" size="xlarge" image="{{user?.imageProfile}}" class="mr-2"
                            shape="circle" />
                        <p-avatar label="{{ user?.name | slice:0:2 }}" *ngIf="!user?.imageProfile" styleClass="mr-2"
                            size="xlarge" shape="circle" />
                        <span class="inline-flex flex-column" style="gap: 3px;">
                            <span class="font-bold">{{ user?.name }}</span>
                            <span class="font-light">{{ user?.email }}</span>

                            <p-chip label="{{userRoleService.getRole()?.roleName || 'Usuario'}}" class="mr-2"></p-chip>
                         

                        </span>
                    </button>
                    <p-card label="Centros a cargo" *ngIf="isAdminWorkcenter()">
                     <div class="p-fluid">
                       <h5>Centros a cargo</h5>
                        <ul *ngIf="userRoleService.getRole()?.workCenters?.length">
                            <li *ngFor="let wc of userRoleService.getRole()?.workCenters || []">
                                {{ wc.name }}
                            </li>
                        </ul>
                        </div>
                        </p-card>
                </ng-template>
            </p-menu>

        </p-overlayPanel>
        <!-- <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-cog"></i>
            <span>Settings</span>
        </button> -->
    </div>

</div>
<section *ngIf="isSessionBootstrapping" class="tenant-session-skeleton" aria-live="polite" aria-busy="true">
    <div class="tenant-session-skeleton__shell">
        <div class="tenant-session-skeleton__hero">
            <p-skeleton width="60%" height="2.2rem" styleClass="mb-3"></p-skeleton>
            <p-skeleton width="40%" height="1rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="8rem" height="1.6rem" borderRadius="1rem"></p-skeleton>
        </div>

        <div class="tenant-session-skeleton__section">
            <p-skeleton width="12rem" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="18rem" height="0.9rem" styleClass="mb-3"></p-skeleton>
            <div class="tenant-session-skeleton__card">
                <p-skeleton shape="circle" size="3rem"></p-skeleton>
                <div class="tenant-session-skeleton__card-text">
                    <p-skeleton width="10rem" height="1.1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="100%" height="0.85rem"></p-skeleton>
                </div>
            </div>
        </div>

        <div class="tenant-session-skeleton__section">
            <p-skeleton width="11rem" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="16rem" height="0.9rem" styleClass="mb-3"></p-skeleton>
            <div class="tenant-session-skeleton__grid">
                <p-skeleton *ngFor="let _ of [1,2,3,4,5,6]" width="100%" height="4.5rem" borderRadius="0.85rem"></p-skeleton>
            </div>
        </div>
    </div>
</section>
<section *ngIf="hasMissingCompanyContext" class="tenant-context-empty-state" aria-live="polite">
    <div class="tenant-context-empty-state__background">
        <span class="tenant-context-empty-state__bubble tenant-context-empty-state__bubble--one"></span>
        <span class="tenant-context-empty-state__bubble tenant-context-empty-state__bubble--two"></span>
        <span class="tenant-context-empty-state__bubble tenant-context-empty-state__bubble--three"></span>
    </div>

    <article class="tenant-context-empty-card">
        <div class="tenant-context-empty-card__badge">
            <i class="pi pi-shield"></i>
        </div>

        <p class="tenant-context-empty-card__eyebrow">Seguridad y salud en el trabajo</p>
        <h2>No pudimos cargar tu compañía activa</h2>
        <p class="tenant-context-empty-card__message">
            Tu usuario fue autenticado, pero la sesión no recibió una compañía y rol válidos.
            Para proteger la trazabilidad de los datos de SST, detuvimos la carga del portal.
        </p>

        <div class="tenant-context-empty-card__checks">
            <span><i class="pi pi-user"></i> Usuario identificado</span>
            <span><i class="pi pi-building"></i> Compañía pendiente</span>
            <span><i class="pi pi-id-card"></i> Rol pendiente</span>
        </div>

        <div class="tenant-context-empty-card__actions">
            <button pButton type="button" icon="pi pi-refresh" label="Reintentar contexto"
                class="p-button-rounded p-button-outlined p-button-success"
                (click)="retryTenantContext()">
            </button>
            <button pButton type="button" icon="pi pi-sign-out" label="Cerrar sesión"
                class="p-button-rounded p-button-danger"
                (click)="logout()">
            </button>
        </div>
    </article>
</section>
<p-sidebar [(visible)]="modalSwitch" showCloseIcon="false" dismissible="false" position="right"
    [style]="{width: '550px'}">
    <h4>Cambiar compañia</h4>
    <div class="p-fluid">

        <div class="field" *ngIf="companyList.length > 0">
            <label for="workcenterSelect" class="block mb-2 font-semibold text-sm">Seleccionar Compañia</label>
            <p-dropdown [options]="companyList" [(ngModel)]="selectedCompany" optionLabel="companyName" 
                placeholder="Seleccionar Compañia" />
        </div>
        <p-card *ngIf="isAdminWorkcenter()">
            <h5>Centros a cargo</h5>
            <ul *ngIf="currentRole?.workCenters?.length">
                <li *ngFor="let wc of currentRole?.workCenters || []">
                    {{ wc.name }}
                </li>
            </ul>
        </p-card>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between mt-1">
            <div>
                <p-button (click)="modalSwitch=false" label="Cancelar"
                    styleClass="p-button-rounded p-button-danger"></p-button>
            </div>
            <div>
                <p-button icon="pi pi-save" (click)="onSelectCompany(selectedCompany!.companyId)" label="Cambiar"
                    styleClass="p-button-rounded"></p-button>
            </div>
        </div>
    </ng-template>
</p-sidebar>